import { render, staticRenderFns } from "./addClinicalImages.vue?vue&type=template&id=7043877e&scoped=true"
import script from "./addClinicalImages.vue?vue&type=script&lang=js"
export * from "./addClinicalImages.vue?vue&type=script&lang=js"
import style0 from "./addClinicalImages.vue?vue&type=style&index=0&id=7043877e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043877e",
  null
  
)

export default component.exports